/**
 * @author Leonel Martinez 
 * @description `inquiryService` Get parts from the catalog
 * @exports inquiryService
 */
import { API } from "@/services";
import { http } from "@/utils";

export const inquiryService = {
  inquiry: (page, size, group_by, request) =>
    http.post(`${API.INQUIRY}?page=${page}&size=${size}&group_by=${group_by}`, request).catch(e => e.response),

  getC2C: (catalog_number, part_number) =>
    http.get(`${API.C2C.URL}/${catalog_number}/?q=${part_number}`).catch(e => e.response),

  getThumbnail: (catalogOrderNumber, part_number, signal) =>
    http.get(`${API.C2C.THUMBNAIL}/${catalogOrderNumber}?q=${part_number}`, { signal: signal }).catch(e => e.response),

  uniqueDescriptions: (request) => 
    http.post(`${API.UNIQUE_DESCRIPTIONS}`, request).catch(e => e.response)
 };